import { render, staticRenderFns } from "./rescue.vue?vue&type=template&id=ba95ae36&scoped=true&"
import script from "./rescue.vue?vue&type=script&lang=js&"
export * from "./rescue.vue?vue&type=script&lang=js&"
import style0 from "./rescue.vue?vue&type=style&index=0&id=ba95ae36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba95ae36",
  null
  
)

export default component.exports